import { render, staticRenderFns } from "./TimeDilationTab.vue?vue&type=template&id=d9200254&scoped=true&"
import script from "./TimeDilationTab.vue?vue&type=script&lang=js&"
export * from "./TimeDilationTab.vue?vue&type=script&lang=js&"
import style0 from "./TimeDilationTab.vue?vue&type=style&index=0&id=d9200254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9200254",
  null
  
)

export default component.exports